import {
  LOGIN, SET_ORGANISATION, SET_IS_OTP_SENT,
  SET_USER_INFO, PREV_URL, STEP, SET_OTP_VERIFIED,
  SET_INTRO_STEPS, SET_GAME_INTRO_STEPS,
  SET_GAME_ID, SET_SHOW_DICE_BTN, SET_GAME_STATE,
  SET_VALUE_BUDDY_CHOOSEN, SET_CORRECT_VALUE_BUDDIES,
  SET_TOKENS, SET_GATE_POSITIONS, SET_TIMER, SET_PAUSE_GAME, SET_REMAINING_TIME,
  SET_TIMER_ID, ADD_INTERVAL, CLEAR_ALL_INTERVALS,
  CHOOSE_VALUE_BUDDY_MODAL,
  SET_FEEDBACK_QUESTIONS,
  SET_POLL_QUESTIONS,
  SET_USER_DETAILS,
  PLAY_AUDIO

} from "../actions/action";


import tokenwater from "../../assets/tokens/1.png"
import tokenfire from "../../assets/tokens/2.png"
import tokenearth from "../../assets/tokens/3.png"
import tokenAir from "../../assets/tokens/4.png"

import reqCard1 from "../../assets/magnus-intro/Right answerreq-cards-1.svg"
import reqCard2 from "../../assets/magnus-intro/Right answerreq-cards-2.svg"
import reqCard3 from "../../assets/magnus-intro/Right answerreq-cards-3.png"
import reqCard4 from "../../assets/magnus-intro/Wrong answerreq-cards-4.svg"

import waterIc from "../../assets/selectTokens/Water.png"
import fireIc from "../../assets/selectTokens/Fire.png"
import eartIc from "../../assets/selectTokens/Earth.png"
import airIc from "../../assets/selectTokens/Air.png"


import dice1 from "../../assets/dice/01.gif";
import dice2 from "../../assets/dice/02.gif";
import dice3 from "../../assets/dice/03.gif";
import dice4 from "../../assets/dice/04.gif";
import dice5 from "../../assets/dice/05.gif";
import dice6 from "../../assets/dice/06.gif";


import gameboard from '../../assets/gameBoard/play-board.png'

import redDot from "../../assets/learningCardIcons/redDot.svg"
import listIc from "../../assets/learningCardIcons/listIc.svg"
import minudIc from "../../assets/learningCardIcons/minusIc.svg"
import sendIc from "../../assets/learningCardIcons/sendIc.svg"



const initialState = {
  auth: null,
  assets: [],
  cards: [reqCard1, reqCard2, reqCard3, reqCard4],

  selectTokens: [
    { id: 1, name: "Water", image: waterIc, color: "#B0E2FF" },
    { id: 2, name: "Fire", image: fireIc, color: "#FDA39D" },
    { id: 3, name: "Earth", image: eartIc, color: "#94FF94" },
    { id: 4, name: "Air", image: airIc, color: "#FFEF9D" },
  ],
  tokenCard: [{ id: 1, card: tokenwater, image: waterIc }, { id: 2, card: tokenfire, image: fireIc }, { id: 3, card: tokenearth, image: eartIc }, { id: 4, card: tokenAir, image: airIc }],
  gameIntroSteps: 0,
  introSteps: 0,
  valueBuddiesImg: [
    { image: null, id: 1, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 2, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 3, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 4, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 5, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 6, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 7, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 8, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 9, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 10, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 11, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 12, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 13, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 14, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 15, happy: null, sad: null, thumbsUp: null, withName: null, name: "" },
    { image: null, id: 16, happy: null, sad: null, thumbsUp: null, withName: null, name: "" }
  ],
  learningCardData: [
    {
      icon: redDot,
    },
    {
      icon: sendIc,
    },
    {
      icon: listIc,
    },
    {
      icon: minudIc,
    },
  ],

  gatePositions: [],
  dice: {
    1: dice1,
    2: dice2,
    3: dice3,
    4: dice4,
    5: dice5,
    6: dice6
  },
  showDiceBtn: true,
  gameboard: gameboard,
  selectedToken: null,
  remainingTime: 1,
  chooseValueModal: false,
  gameAssets: {},
  utilAssets: {},
  tokenIconAssets: {},
  tokenCardAssets: {},
  diceAssets: {},
  valueBuddyDesc: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      if (action.val) {
        return {
          ...state,
          auth: action.val
        }
      } else {
        return {
          ...state,
          auth: null,
          gameState: null,
          showDiceBtn: true,
          gameIntroSteps: 0,
          introSteps: 0,
          isValueBuddySelected: false,
          gameId: null,
          step: undefined,
          learningCardData: initialState.learningCardData,
          valueBuddiesImg: initialState.valueBuddiesImg,

        }
      }
    case SET_ORGANISATION:
      return {
        ...state,
        organisation: action.val
      }
    case SET_IS_OTP_SENT:
      return {
        ...state,
        isOtpSent: action.val
      }
    case SET_USER_INFO:
      return {
        ...state,
        userInfo: action.val
      }
    case SET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.val
      }
    case PREV_URL:
      return {
        ...state,
        prevUrl: action.val
      }
    case STEP:
      return {
        ...state,
        step: action.val
      }

    case SET_OTP_VERIFIED:
      return {
        ...state,
        otpVerified: action.val
      }
    case SET_INTRO_STEPS:
      return {
        ...state,
        introSteps: action.val
      }
    case SET_GAME_INTRO_STEPS:
      return {
        ...state,
        gameIntroSteps: action.val
      }
    case SET_GAME_ID:
      return {
        ...state,
        gameId: action.val
      }
    case SET_SHOW_DICE_BTN:
      return {
        ...state,
        showDiceBtn: action.val
      }
    case SET_GAME_STATE:
      return {
        ...state,
        gameState: action.val
      }
    case SET_VALUE_BUDDY_CHOOSEN:
      return {
        ...state,
        isValueBuddySelected: action.val
      }
    case SET_CORRECT_VALUE_BUDDIES:
      return {
        ...state,
        correctValueBuddies: action.val
      }
    case SET_TOKENS:
      return {
        ...state,
        tokenNames: action.val
      }
    case SET_GATE_POSITIONS:
      return {
        ...state,
        gatePositions: action.val
      }
    case SET_TIMER:
      return {
        ...state,
        timer: action.val
      }
    case SET_REMAINING_TIME:
      return {
        ...state,
        remainingTime: action.val
      }
    case SET_PAUSE_GAME:
      return {
        ...state,
        isGamePaused: action.val
      }
    case SET_TIMER_ID:
      return {
        ...state,
        timerId: action.val
      }

    case ADD_INTERVAL:
      return {
        ...state,
        intervalIds: [...state.intervalIds, action.val]
      };
    case CLEAR_ALL_INTERVALS:
      state.intervalIds?.forEach((id) => clearInterval(id));
      return {
        ...state,
        intervalIds: []
      };
    case CHOOSE_VALUE_BUDDY_MODAL:
      return {
        ...state,
        chooseValueModal: action.val
      };

    case SET_POLL_QUESTIONS:
      return {
        ...state,
        pollQuestions: action.val
      };

    case SET_FEEDBACK_QUESTIONS:
      return {
        ...state,
        learningCardData: action.val
      };

    case PLAY_AUDIO:
      return {
        ...state,
        isPlaying: action.val
      }


    default:
      return { ...state };
  }
};

export default reducer;
